<!-- 修改申请 -->
<!-- 申请单申请页面 -->
<template>
  <div class="app-container">
    <el-card>
      <el-divider
        direction="horizontal"
        :style="{ color: '#1989fa', borderColor: '#d0e6ff', padding: '0 5px' }"
        content-position="left"
      >
        <h3 class="form-title" style="color: #409eff; font-weight: bolder">
          申请单信息
        </h3>
      </el-divider>
      <el-form
        ref="formRef"
        class="mt25"
        :model="formData"
        inline
        label-position="top"
        :rules="formRules"
      >
        <el-form-item prop="name" label="申请单名称">
          <el-input v-model="formData.name" style="width: 240px" />
        </el-form-item>
        <el-form-item label="申请单类型" prop="type">
          <el-select
            v-model="formData.type"
            filterable
            clearable
            placeholder="请选择申请单类型"
            style="width: 240px"
            @change="handleApplicationTypeChange"
          >
            <el-option
              v-for="subItem in getDictListByParentCode('applicationType')"
              :key="subItem.libraryCode"
              :label="subItem.libraryName"
              :value="subItem.libraryCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="出入库类型" prop="outInStatus">
          <el-select
            v-model="formData.outInStatus"
            filterable
            clearable
            placeholder="请选择出入库类型"
            style="width: 240px"
            @change="handleOutInStatusChange"
          >
            <el-option
              v-for="subItem in getDictListByParentCode('outInStatus')"
              :key="subItem.libraryCode"
              :label="subItem.libraryName"
              :value="subItem.libraryCode"
            />
          </el-select>
        </el-form-item>
        <!-- 退货入库 -->
        <template v-if="formData.type === '1' && formData.outInStatus === '1'">
          <el-form-item label="入库仓库" prop="inWarehouse">
            <el-select
              v-model="formData.inWarehouse"
              filterable
              clearable
              placeholder="请选择入库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in warehouseList"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
        </template>
        <!-- 退货出库 -->
        <template v-if="formData.type === '1' && formData.outInStatus === '2'">
          <el-form-item label="出库仓库" prop="outWarehouse">
            <el-select
              v-model="formData.outWarehouse"
              filterable
              clearable
              placeholder="请选择出库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in warehouseList"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
        </template>
        <!-- 调拨入库 -->
        <template v-if="formData.type === '2' && formData.outInStatus === '1'">
          <el-form-item label="入库仓库" prop="inWarehouse">
            <el-select
              v-model="formData.inWarehouse"
              filterable
              clearable
              placeholder="请选择入库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in warehouseList"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="出库仓库" prop="outWarehouse">
            <el-select
              v-model="formData.outWarehouse"
              filterable
              clearable
              placeholder="请选择出库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in warehouseList"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
        </template>
        <!-- 调拨出库 -->
        <template v-if="formData.type === '2' && formData.outInStatus === '2'">
          <el-form-item label="出库仓库" prop="outWarehouse">
            <el-select
              v-model="formData.outWarehouse"
              filterable
              clearable
              placeholder="请选择出库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in warehouseList"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="入库仓库" prop="inWarehouse">
            <el-select
              v-model="formData.inWarehouse"
              filterable
              clearable
              placeholder="请选择入库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in warehouseList"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="备注">
          <el-input v-model="formData.remarks" style="width: 240px" />
        </el-form-item>
      </el-form>
      <el-divider
        direction="horizontal"
        :style="{
          color: '#1989fa',
          borderColor: '#d0e6ff',
          marginTop: '25px',
          padding: '0 5px',
        }"
        content-position="left"
      >
        <h3 class="form-title" style="color: #409eff; font-weight: bolder">
          申请产品信息
        </h3>
      </el-divider>
      <SelectProductTable
        class="mt25"
        ref="selectProductTableRef"
        :data="selectProductTableData"
        :isApplication="true"
        :warehouseId="
          formData.outInStatus === '1'
            ? formData.inWarehouse
            : formData.outWarehouse
        "
      />
      <el-divider
        direction="horizontal"
        border-style="dashed"
        :style="{ color: '#1989fa', borderColor: '#d0e6ff' }"
      >
      </el-divider>
      <el-row :gutter="8" class="mt5">
        <el-col :span="1.5">
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script setup>
import { onUnmounted, ref } from "vue";
import SelectProductTable from "@/views/warehouse/components/SelectProductTable";
import useCacheStore from "@/store/modules/cache";
import { updateApplicationForm } from "@/api/warehouse/applicationForm";
import { selectProductRecordsByApplicationFormId } from "@/api/warehouse/outInWarehouse";
import { isNull } from "@/utils/fangerUtils";
import { errorMsg } from "@/utils/msgBox";
import useApplicationFormStore from "@/store/modules/applicationForm";
import useTagsViewStore from "@/store/modules/tagsView";
import { useRouter } from "vue-router";

const cacheStore = useCacheStore();
const { getDictListByParentCode, getProductById } = cacheStore;

const applicationFormStore = useApplicationFormStore();

const router = useRouter();

const curRouter = router.currentRoute.value;

const warehouseList = cacheStore.warehouse;
const formRef = ref(null);
const selectProductTableRef = ref(null);
const selectProductTableData = ref([]);
// 表单数据
const formData = ref(applicationFormStore.updateData);
// 获取选择的产品数据

(() => {
  selectProductRecordsByApplicationFormId(formData.value.applicationFormId)
    .then((res) => {
      const productTableData = [];
      res.data.forEach((item) => {
        productTableData.push({
          ...getProductById(item.productId),
          ...item,
        });
      });
      selectProductTableData.value = productTableData;
    })
    .catch(() => {});
})();

// 申请类型改变
const handleApplicationTypeChange = (value) => {
  delete formData.value.outWarehouse;
  delete formData.value.inWarehouse;
};

// 出入库类型改变
const handleOutInStatusChange = (value) => {
  delete formData.value.outWarehouse;
  delete formData.value.inWarehouse;
};

// 提交数据
const handleSubmit = () => {
  formRef.value.validate((valid) => {
    if (!valid) return;
    const productData = selectProductTableRef.value.getProductData();
    if (productData === null) return;
    // if (productData.length === 0) {
    //   errorMsg("请选择产品，最少选择一个产品");
    //   return;
    // }
    formData.value.jsonData = JSON.stringify(productData);
    if (!isNull(formData.value.applicationFormId)) {
      // 新增
      updateApplicationForm(formData.value)
        .then((res) => {
          // 重置表单
          // formRef.value.resetFields();
          applicationFormStore.updateSuccessFlag = true;
          router.go(-1);
        })
        .catch((res) => {});
    }
  });
};

// 表单规则
const formRules = {
  name: [
    {
      required: true,
      trigger: "blur",
      message: "申请单名称为必填项",
    },
  ],
  type: [
    {
      required: true,
      trigger: "blur",
      message: "申请单类型为必填项",
    },
  ],
  outInStatus: [
    {
      required: true,
      trigger: "blur",
      message: "出入库状类型为必填项",
    },
  ],
  inWarehouse: [
    {
      required: true,
      trigger: "blur",
      message: "入库仓库为必填项",
    },
  ],
  outWarehouse: [
    {
      required: true,
      trigger: "blur",
      message: "出库仓库为必填项",
    },
  ],
};

onUnmounted(() => {
  useTagsViewStore().delView(curRouter);
  applicationFormStore.updateData = {};
});
</script>

<style lang="scss" scoped></style>
